import React, { useState, useEffect } from 'react';
import TransactionList from '../../components/History/TransactionList/TransactionList';
import './HistoryPage.css';
import { useProfile } from '../../hooks/useProfile';
import { useTranslation } from 'react-i18next';

const HistoryPage = () => {
  const [transactions, setTransactions] = useState([]);
  const [filter, setFilter] = useState('ALL');
  const { profile, error, loading} = useProfile();

  const { t } = useTranslation("history");

  useEffect(() => {
    if(loading) return;
    if(error) return;

    setTransactions(profile.transactions)

  }, [loading]);

  const filterOptions = [
    { value: 'ALL', label: t("ALL")},
    { value: 'NEW', label: t("NEW")},
    { value: 'BUY', label: t("BUY")},
    { value: 'SELL', label: t("SELL")},
  ];

  const filteredTransactions = () => {
    switch(filter){
      case 'ALL':
        return transactions
      case 'NEW':
        return transactions.filter(tx => tx.status === filter);
      default:
        return transactions.filter(tx => tx.operation === filter);
    }
  }

  if (loading) {
    return (
      <div className="history-page">
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p> { t("LOADING_HISTORY") } </p>
        </div>
      </div>
    );
  }

  return (
    <div className="history-page">
      <div className="history-header">
        <h3>{ t("HISTORY") }:</h3>
        <div className="history-filters">
          {filterOptions.map(option => (
            <button
              key={option.value}
              className={`filter-btn ${filter === option.value ? 'active' : ''}`}
              onClick={() => setFilter(option.value)}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>
      
      <TransactionList transactions={filteredTransactions()} />
    </div>
  );
};

export default HistoryPage;